export default (dir = 'down', callback) => {
  let lastScroll = 0;
  window.addEventListener('scroll', (e) => {
    const currentScroll = window.scrollY || document.body.scrollTop;
    if (currentScroll > 0 && lastScroll <= currentScroll) {
      lastScroll = currentScroll;
      if (dir === 'down' && callback) return callback();
      window.dispatchEvent(new Event('scrollDown'));
    } else {
      lastScroll = currentScroll;
      if (dir === 'up' && callback) return callback();
      window.dispatchEvent(new Event('scrollUp'));
    }

    if (window.scrollY <= 0) {
      if (dir === 'top' && callback) return callback();
      window.dispatchEvent(new Event('scrollToTop'));
    }
  }, {passive: true});
};
